import axios, { CreateAxiosDefaults } from "axios";

export const baseURL = `${process.env.REACT_APP_API_URL}/graphql`;

type Headers = CreateAxiosDefaults<any>["headers"];

export const getClient = async (headers?: Headers, timeout = 5 * 60 * 1000) => {
  return axios.create({ baseURL, timeout, headers });
};
